var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0176 7.47798L20.7698 5.72578C21.7375 4.75807 23.3065 4.75807 24.2742 5.72578C25.2419 6.6935 25.2419 8.26247 24.2742 9.23018L22.522 10.9824M19.0176 7.47798L8.72529 17.7704C7.41866 19.077 6.76532 19.7302 6.32046 20.5264C5.87559 21.3225 5.428 23.2024 5 25C6.79761 24.572 8.67749 24.1244 9.47361 23.6795C10.2697 23.2346 10.923 22.5814 12.2297 21.2747L22.522 10.9824M19.0176 7.47798L22.522 10.9824",
    stroke: "#7A6C31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 25H21.25",
    stroke: "#7A6C31",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.08482c30ae5d68506b66df84d532e9bb.svg";
export { ForwardRef as ReactComponent };